import { ICellRendererComp, ICellRendererParams } from '@ag-grid-community/core';
import { HIGHLIGHT_AMBER_BG, HIGHLIGHT_AMBER_COLOR } from '../../../styles';
import { isOrderPeriodDatesApplicable } from '../deal-series/deal-status';

export class BadgeRenderer implements ICellRendererComp {
  params: ICellRendererParams;

  eGui: HTMLElement;

  init(params: ICellRendererParams) {
    this.params = params;
    this.renderBadge();
  }

  private renderBadge(): void {
    this.eGui = document.createElement('div');
    this.eGui.style.display = 'flex';
    this.eGui.style.alignItems = 'center';
    this.eGui.style.justifyContent = (this.params as any).justifyContent || 'center';
    this.eGui.style.height = '100%';
    this.eGui.style.width = '100%';
    this.eGui.style.background = (this.params as any).background;
    this.eGui.style.gap = '6px';

    if ((this.params as any).badgeText) {
      const badge = document.createElement('icon-status-badge');
      badge.setAttribute('background-color', (this.params as any).badgeFillColor);
      badge.setAttribute('color', (this.params as any).badgeColor);
      badge.setAttribute('badge-text', (this.params as any).badgeText);

      if ((this.params as any).badgeIcon) {
        badge.setAttribute('icon-name', (this.params as any).badgeIcon);
      }
      this.eGui.append(badge);
    }

    const startDate = (this.params as any).orderPeriodBeginDate;
    const endDate = (this.params as any).orderPeriodEndDate;
    const dealStatus = (this.params as any).dealStatusForOrderPeriod as string | null | undefined;

    if (isOrderPeriodDatesApplicable(dealStatus) && startDate && endDate) {
      const pill = document.createElement('rapid-status-pill');
      pill.setAttribute('background-color', HIGHLIGHT_AMBER_BG);
      pill.setAttribute('text-color', HIGHLIGHT_AMBER_COLOR.trim());
      pill.setAttribute('date-countdown', String(endDate));
      pill.setAttribute('hide-when-countdown-completed', '');
      pill.setAttribute('date-countdown-visible-after', String(startDate));
      pill.style.display = 'flex'
      this.eGui.append(pill);
    }
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    this.renderBadge();
    return true;
  }
}
